import { render, staticRenderFns } from "./cp_compMenu.vue?vue&type=template&id=714a1b61&scoped=true"
import script from "./cp_compMenu.vue?vue&type=script&lang=js"
export * from "./cp_compMenu.vue?vue&type=script&lang=js"
import style0 from "./cp_compMenu.vue?vue&type=style&index=0&id=714a1b61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714a1b61",
  null
  
)

export default component.exports